export default function AboutUs () {
  return (
    <section className='section'>
      <article className='about-us'>
        <h2>Acerca de nosotros</h2>
        <p>👋 ¡Hola!, somos Mohana Indumentaria, un emprendimiento familiar basado en la venta minorista de indumentaria y calzado femenino.</p>
        <p>Nos encontramos físicamente en La Gallareta, provincia de Santa Fe.</p>
        <p>Podes visitar nuestra página online actualmente en el la siguiente dirección: <i><b><a href='https://www.mohanaindumentaria.com.ar' target='_blank' rel='noreferrer'>Mohana Indumentaria</a></b></i>.</p>
        <p>Realizamos envíos a todo el país y contamos con diferentes métodos de pago.</p>
        <p>¡Muchas gracias por tu atención 🙌!</p>
      </article>
    </section>
  )
}
